// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_CONTEXT_MENU } from '../actions/ContextMenu';
import { SET_STORAGE } from '../actions/Storage';
import ContextMenuButton from '../components/ContextMenuButton';
import Button from '../components/widgets/items/Button';
import Template from '../Contexts/Template';
import { dispatchSkyfireMethods } from '../utils';
import { useSelectedRowCount } from '../utils/MultiSelectHook';
import * as Styles from './MultiSelectBar.scss';
export default function MultiSelectBar() {
    var _a, _b;
    useStyles(Styles);
    const dispatch = useDispatch();
    const template = useContext(Template);
    if (!((_b = (_a = template) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.multiSelectBar)) {
        return null;
    }
    const { selectedText, actionButton1, actionButton2, contextMenu, closeButton, itemCount, } = template.innerTemplate.multiSelectBar;
    const multiSelectCount = useSelectedRowCount();
    if (multiSelectCount <= 0) {
        return null;
    }
    const allSelected = useSelector((state) => { var _a, _b, _c; return ((_c = (_b = (_a = state) === null || _a === void 0 ? void 0 : _a.Storage) === null || _b === void 0 ? void 0 : _b.MULTISELECT) === null || _c === void 0 ? void 0 : _c._all) === 'true'; });
    if (!allSelected && multiSelectCount === itemCount) {
        dispatch({
            type: SET_STORAGE,
            payload: {
                group: 'MULTISELECT',
                key: '_all',
                value: 'true',
            },
        });
    }
    const onClose = useCallback((methods) => {
        dispatchSkyfireMethods(dispatch, template, methods);
        dispatch({ type: CLOSE_CONTEXT_MENU });
    }, [dispatch, template]);
    const onButton1 = useCallback((methods) => { var _a; return !((_a = actionButton1) === null || _a === void 0 ? void 0 : _a.disabled) && dispatchSkyfireMethods(dispatch, template, methods); }, [dispatch, template]);
    const onButton2 = useCallback((methods) => { var _a; return !((_a = actionButton2) === null || _a === void 0 ? void 0 : _a.disabled) && dispatchSkyfireMethods(dispatch, template, methods); }, [dispatch, template]);
    return (React.createElement("div", { className: Styles.multiSelectBar, style: { display: multiSelectCount ? 'block' : 'none' } },
        React.createElement("section", null,
            React.createElement("div", { className: "music-headline-4" }, selectedText.replace('0', '' + multiSelectCount)),
            React.createElement("div", null,
                actionButton1 && (React.createElement(Button, { variant: "glass", data: actionButton1, handleSelected: onButton1 })),
                actionButton2 && (React.createElement(Button, { variant: "glass", data: actionButton2, handleSelected: onButton2 })),
                contextMenu && (React.createElement(ContextMenuButton, { size: "small", iconName: "more", variant: "glass", disabled: contextMenu.disabled, options: contextMenu.options })),
                React.createElement(Button, { variant: "glass", size: "small", data: closeButton, handleSelected: onClose })))));
}
